import * as types from './types';
import {
  SchoolAdminToolBookStatementStudentCourseListModel,//学生导入列表
  ToolBookStatementStudentCourseDelete,//班级删除学生
  SchoolAdminToolSupplyDataImportModel,//导入补订信息
} from 'src/model/AdminModel';

export default{
  //学生导入列表
  actionGetSettlementToolStudentList({state,commit},query){
    commit(types.ACTION_GET_SETTLEMENT_TOOL_STUDENT_LIST, {
      state: 'loading'
    });
    return SchoolAdminToolBookStatementStudentCourseListModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_GET_SETTLEMENT_TOOL_STUDENT_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_GET_SETTLEMENT_TOOL_STUDENT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  // 导入补订信息
   actionSchoolAdminToolSupplyDataImportModel({commit, state}, query){
     return SchoolAdminToolSupplyDataImportModel.getInstance().execute(query);
   },

  //班级删除学生
  actionGetSettlementToolBatchDeleteImport({state,commit},query){
    return ToolBookStatementStudentCourseDelete.getInstance().execute(query)
  },
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/tooBookStudentList/actions.js